
import FolderFavorite from "../../../assets/duotone/FolderFavorite.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FolderFavoriteIcon({ className, dataTestid = "FolderFavoriteIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FolderFavorite data-testid={dataTestid} className={classes} {...rest} />
  );
}
